import * as React from 'react'

export const ExportIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.75 1H11.25C11.6562 1 12 1.34375 12 1.75C12 2.1875 11.6562 2.5 11.25 2.5H0.75C0.3125 2.5 0 2.1875 0 1.75C0 1.34375 0.3125 1 0.75 1ZM6.53125 5.25L10.5312 9.5C10.8125 9.8125 10.8125 10.2812 10.5 10.5625C10.1875 10.8438 9.71875 10.8438 9.4375 10.5312L6.75 7.65625V10.25V14.25C6.75 14.6875 6.40625 15 6 15C5.5625 15 5.25 14.6875 5.25 14.25V10.25V7.65625L2.53125 10.5312C2.25 10.8438 1.78125 10.8438 1.46875 10.5625C1.15625 10.2812 1.15625 9.8125 1.4375 9.5L5.4375 5.25C5.59375 5.09375 5.78125 5 6 5C6.1875 5 6.40625 5.09375 6.53125 5.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
